import React from 'react';
import {
  Grid,
  Card,
  Container,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Badge,
  Box,
  Button,
} from '@mui/material';
import Header from '../components/Admin/header/Header';
import Sidebar from '../components/Admin/Sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import { Search } from '@mui/icons-material';
import { UserPlus, X } from 'lucide-react';

const consultationData = [
  {
    subheading: 'Consultations Included',
    points: [
      'Follow-up with Patient John Doe: Scheduled for September 14, 2024, at 10:00 AM.',
      'Charges Per Visit: 500 INR.',
      'Total Visit Charges: 9500 INR.',
    ],
  },
  {
    subheading: 'Pharmacy Items Included',
    points: [
      'Follow-up with Patient John Doe: Scheduled for September 14, 2024, at 10:00 AM.',
      'Medication Stock Check (Pharmacy): Due by September 14, 2024, at 2:00 PM.',
      'Team Meeting (Nursing User): Scheduled for September 15, 2024, at 11:00 AM in Room 1A.',
    ],
  },
  {
    subheading: 'Pharmacy Items Included',
    points: [
      'Follow-up with Patient John Doe: Scheduled for September 14, 2024, at 10:00 AM.',
      'Medication Stock Check (Pharmacy): Due by September 14, 2024, at 2:00 PM.',
      'Team Meeting (Nursing User): Scheduled for September 15, 2024, at 11:00 AM in Room 1A.',
    ],
  },

  {
    subheading: 'Services Included',
    points: [
      'Follow-up with Patient John Doe: Scheduled for September 14, 2024, at 10:00 AM.',
      'Medication Stock Check (Pharmacy): Due by September 14, 2024, at 2:00 PM.',
      'Team Meeting (Nursing User): Scheduled for September 15, 2024, at 11:00 AM in Room 1A.',
    ],
  },
];

const PackageDetails = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/patient/packages/details/add');
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: 'flex' }}>
        <Box sx={{}}>
          <Sidebar />
        </Box>

        <Box
          sx={{
            paddingTop: '20px',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '20px',
            marginRight: '80px',
            width: '100%',
          }}
        >
          {/* Search  */}
          <Box
            sx={{
              paddingTop: '20px',
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                backgroundColor: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
              }}
            >
              <select className="uid-select">
                <option value="UHID">UHID</option>
                <option value="firstName">Patient's First Name</option>
                <option value="contactNo">Contact Number</option>
              </select>
              <div className="search-input-wrapper">
                <Search className="search-icon" size={20} />
                <input
                  type="text"
                  placeholder={`Search by `}
                  className="search-input"
                />

                <button
                  className="clear-search"
                  style={{
                    position: 'absolute',
                    right: '10px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#999',
                  }}
                >
                  <X size={16} />
                </button>
              </div>
            </Box>
            <Box>
              <button
                className="patient-registration"
                onClick={() => {
                  navigate('/consultation/form');
                }}
              >
                <UserPlus size={20} />
                Add Consultation
              </button>
            </Box>
          </Box>
          <Typography variant="h6" color="#5D6A82" mt={2} mb={2}>
            Details of the Package
          </Typography>

          <Box
            sx={{
              padding: 3,
              borderRadius: 3,
              border: '1px solid #5D6A82',
            }}
          >
            <Typography
              variant="h5"
              color="#5D6A82"
              sx={{ marginBottom: '1rem' }}
            >
              Maternity Care Package
            </Typography>
            {consultationData.map((section, index) => (
              <Box key={index} sx={{ marginBottom: 3 }}>
                <Typography
                  variant="subtitle1"
                  color="#5D6A82"
                  sx={{ fontWeight: 'bold' }}
                >
                  {section.subheading}
                </Typography>
                <List sx={{ paddingLeft: 2 }}>
                  {section.points.map((point, idx) => (
                    <ListItem
                      key={idx}
                      sx={{
                        display: 'list-item',
                        color: '#5D6A82',
                        listStyleType: 'disc',
                        marginLeft: 2,
                        padding: 0,
                      }}
                    >
                      <ListItemText
                        primary={point}
                        primaryTypographyProps={{
                          fontSize: '16px',
                          lineHeight: '1.7', // Adjust this value as needed
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </Box>
          <Box sx={{ textAlign: 'center' }} mt={2}>
            <Button
              variant="contained"
              color="primary"
              sx={{ padding: '10px 40px', width: '20%', textTransform: 'none' }}
              onClick={handleClick}
            >
              Add Package
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default PackageDetails;
